<script setup lang="ts">
const items = [
  {
    title: 'Multi User Access',
    description:
      'Bagi peran sesuai tanggung jawab (admin, packer, finance, owner).',
    icon: 'material-symbols:groups-outline'
  },
  {
    title: 'Kontrol Akses Aman',
    description: 'Data sensitif hanya untuk yang berwenang.',
    icon: 'material-symbols:control-camera'
  },
  {
    title: 'Audit Trail Otomatis',
    description: 'Semua aktivitas terekam dan bisa ditinjau kapan pun.',
    icon: 'material-symbols:manage-search'
  },
  {
    title: 'Operasional Lebih Cepat',
    description: 'Tak perlu login bergantian',
    icon: 'material-symbols:timer-outline'
  },
  {
    title: 'Transparansi COD',
    description: 'Siapa memproses, siapa mencairkan, semuanya jelas',
    icon: 'material-symbols:visibility-outline-rounded'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Kolaborasi yang Efisien, Bisnis Tetap Aman"
    hero-image="/images/manajemen-staff-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
